import { Component, createSignal, For, Match, onMount, Show, Switch } from "solid-js"
import 'medium-zoom/dist/style.css';
import { Timeline } from "./components/timeline";
import { TimelineFilter } from "./Types";

type EventsTabProps = {
    artist: any;
}
type TimelineEvent = {
    Id: string;
    Name: string;
    Description: string;
    EventType: string;
    StartCalendar: string;
    StartEpoch: string;
    StartProximity: string;
    StartYear: string;
    StartMonth: string;
    StartDay: string;
    EndCalendar: string;
    EndEpoch: string;
    EndProximity: string;
    EndYear: string;
    EndMonth: string;
    EndDay: string;
    DateAddedUTC: string;
    DateModifiedUTC: string;
    AutoGenerated: boolean;
    IsDeleted: boolean;
    ParentId: string;
    AddressId: string;
    Artist?: any;
    Artwork?: any;
    Images: NewImage[]
}
type NewImage = {
    Id: string;
    URL: string;
    Width?: number;
    Height?: number;
    DominantColorHexCode: string;
}
type Filter = {
    ArtistId: string;
    FromYear: string;
    ToYear: string;
    Page: number;
};
type Search ={
    Filter: Filter;
    Count: number;
    Page: number;
    MaxPage: number;
    PageRows: number;
    Results: TimelineEvent[];
}
type Resources = {
    Pages: number[]
}
type CalendarDateProps = {
    year: string;
    month: string;
    day: string;
}
const months = ["January","February","March","April","May","June","July","August","September", "October", "November", "December"];
export const CalendarDate : Component<CalendarDateProps> = ({ year, month, day }) => {
    return (
        <>
            <Show when={year}>
                <Switch>
                    <Match when={month && !day}>
                        <span style="font-size: 1rem;">{months[parseInt(month) - 1]}</span>
                    </Match>
                    <Match when={month && day}>
                        <span style="font-size: 1rem;">{months[parseInt(month) - 1]} {day}</span>
                    </Match>
                </Switch>
                <div style="font-size: 2.25rem;">
                    {year}
                </div>
            </Show>
        </>
    )
}

type Tab = {
    index: number;
    name: string;
    filter: TimelineFilter;
}

export const EventsTab : Component<EventsTabProps> = (props) => {
    const [tabIndex, setTabIndex] = createSignal<number>(0);
    const [tabs, setTabs] = createSignal<Tab[]>([]);
    onMount(async () => {
        setTabs([{
            index: 0,
            name: "Timeline of " + props.artist.Name,
            filter: {
                ArtistId: props.artist.Id,
                ArtistName: props.artist.Name,
                FromYear: props.artist.StartYear,
                ToYear: props.artist.EndYear
            }
        }]);
    });
    const loadNewTab = async (name: string, filter: TimelineFilter) => {
        const index = tabs().length;
        const newTab = {
            index: index,
            name,
            filter
        };
        setTabs([...tabs(), newTab]);
        setTabIndex(index);
    };
    const closeTab = (index: number) => {
        const remaining = tabs()
            .filter(x => x.index != index)
            .map((tab, index) => ({ ...tab, index: index }));
        if (remaining.length == 0) {
            return;
        }
        const maxIndex = remaining.length - 1;
        setTabs(remaining);
        setTabIndex(index >= maxIndex ? maxIndex : index);
    }
    return (
        <>
            <section class="tabs air-gap">
                <ul class="list-inline tablinkgroup unselectable">
                    <For each={tabs()}>{(tab, index) =>
                        <li classList={{ ["active"]: tab.index == tabIndex() }}>
                            <span class="tablink" onClick={(e) => { e.preventDefault(); setTabIndex(index()); }}>{tab.name}</span>
                            <Show when={index() > 0}>
                                &nbsp;<button class="btn btn-default btn-sm" onClick={(e) => { e.preventDefault(); closeTab(tab.index)}}><span class="fa fa-trash"></span></button>
                            </Show>
                        </li>
                    }</For>
                </ul>
            </section>
            <div class="tabgroup">
                <For each={tabs()}>{(tab) =>
                    <Show when={tab.index == tabIndex()}>
                        <div class="tab-pane active">
                            <Timeline filter={tab.filter} onLoadNewTab={loadNewTab} />
                        </div>
                    </Show>
                }</For>
            </div>
        </>
    )
}